// src/components/admin/AdminLayout.tsx
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { handleLogout } from '../../utils/logout';
import { Link } from 'react-router-dom';
import { API_BASE_URL } from '../../config';

interface AdminLayoutProps {
  children: React.ReactNode;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isLoginPage = location.pathname === '/admin/login';

  const handleImportDescriptions = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/admin/import-descriptions`, {
        method: 'POST',
      });

      if (response.ok) {
        const message = await response.text();
        alert(`✅ ${message}`);
      } else {
        alert(`⚠️ Import failed: ${response.statusText}`);
      }
    } catch (error) {
      console.error('Import error:', error);
      alert('❌ An error occurred while importing descriptions.');
    }
  };

  return (
    <div className="admin-layout">
      {!isLoginPage && (
        <header className="admin-header">
          <div className="admin-header-content">
            <div className="admin-title" onClick={() => navigate('/admin/dashboard')}>
              TADR Admin Area
            </div>
            <nav style={{ display: 'flex', gap: '1rem' }}>
              <Link to="/admin/dashboard" style={{ textDecoration: 'none', color: '#333' }}>
                Home
              </Link>
              <Link to="/admin/comments" style={{ textDecoration: 'none', color: '#333' }}>
                Comments
              </Link>
              <button onClick={handleImportDescriptions} className="btn btn-outline-primary">
                Import RSS Descriptions
              </button>
              <button onClick={handleLogout} className="btn btn-outline-danger">
                Logout
              </button>
            </nav>
          </div>
        </header>
      )}

      <main className="admin-main">{children}</main>

      {!isLoginPage && (
        <footer className="admin-footer">
          <p>&copy; {new Date().getFullYear()} TADR Admin</p>
        </footer>
      )}
    </div>
  );
};

export default AdminLayout;